import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Formik, Field } from "formik";
import Yup from "yup";
import { CustomInput, ErrorField } from 'components/form';
import { FORM_TEXTS } from 'CONSTANTS';
import { openModal } from 'ducks/ui/actions';
import { passwordResetConfirm } from 'api/users';
import { Redirect } from 'react-router-dom';
import { Trans, withTranslated } from "components";

const propTypes = {
  language: PropTypes.string.isRequired,
  openModal: PropTypes.func.isRequired,
  uid: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
};

const MODAL_ID = 'password-reset-confirm-info';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.initialData = {
      password: "",
      confirm_password: "",
    };

    const lang = props.language;

    this.validationSchema = Yup.object().shape({
      password: Yup.string().required(FORM_TEXTS.required[lang]),
      confirm_password: Yup.string().test("match", FORM_TEXTS.confirm_password[lang], function(password) {
        return password === this.parent.password;
      }).required(FORM_TEXTS.required[lang]),
    })
  }

  handleSubmit = async (values, { setErrors, setSubmitting }) => {
    const data = {
      new_password: values.password,
      uid: this.props.uid,
      token: this.props.token
    };
    try {
      await passwordResetConfirm(data);
      this.SUCCESS = true;
      this.props.openModal(MODAL_ID).then(() => {
        this.forceUpdate();
      });
    } catch({ error }) {
      const { t } = this.props;
      if(error && (error.uid || error.token || error.message)) {
        error.uidTokenError = t('Nie można zmienić hasła dla tego użytkownika. Spróbuj wygenerować nowy link.');
      }
      setErrors(error);
      setSubmitting(false);
    }
  }

  render() {
    const { t } = this.props;
    if(this.SUCCESS) return <Redirect to="/login" />

    return (
      <Formik
        initialValues={this.initialData}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit}
        render={({ errors, handleSubmit, isSubmitting }) => (
          <form action="#" onSubmit={handleSubmit} noValidate={true}>
            <Field name="password" type="password" label={t("Nowe hasło")} component={CustomInput} />
            <Field name="confirm_password" type="password" label={t("Powtórz nowe hasło")} component={CustomInput} />
            <div className="btn-container btn-container--btns-on-right nomargin">
              <button className="full-btn" type="submit" onClick={handleSubmit} disabled={isSubmitting}>
                <Trans>Zmień hasło</Trans>
              </button>
            </div>
            <ErrorField text={errors.uidTokenError} />
          </form>
        )}
      />
    );
  }
}

const mapState = state => ({
  language: state.ui.language
});

const mapDispatch = {
  openModal
};

const enhance = compose(
  connect(mapState, mapDispatch),
  withTranslated,
);

Login.propTypes = propTypes;
export default enhance(Login);


// WEBPACK FOOTER //
// ./src/pages/password/confirm/Form.jsx